import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2ccab276&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogPageBreadCrumb: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/blog/BlogPageBreadCrumb.vue').default,CmsRichText: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/cms/CmsRichText.vue').default,BlogItem: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/blog/BlogItem.vue').default,BlogPagination: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/blog/BlogPagination.vue').default})
